/**
 * 근태 감사 로그 쿼리 키 팩토리.
 *
 * ⚠️ **`attendanceKeys`(루트 `attendances`)와 합치면 안 된다.** 근태 mutation 이
 * `attendances` 를 광역 무효화하는데, 감사 로그가 그 안에 있으면 근태를 한 건 고칠 때마다
 * 로그 목록까지 다시 받는다. 테스트가 이 분리를 못박고 있다(`attendanceKeys.ts` 20-24행).
 *
 * `system-audit`(시스템 감사 로그)과도 별개 루트다 — 서로의 접두사가 되면 한쪽 무효화가
 * 다른 쪽 캐시를 날린다(`systemAuditKeys.ts` 도크스트링).
 *
 * 무효화하는 곳은 **0곳**이다 — 감사 로그는 append-only 라 화면에서 바꾸는 경로가 없다.
 *
 * 회귀 가드: `__tests__/auditLogKeys.test.ts`.
 */
import { defineQueryKeys } from '@/shared/lib/queryKeys';
import type { AuditLogFilters } from '@aegislab/shared';

type ViewFilters = Pick<AuditLogFilters, 'userId' | 'startDate' | 'endDate'>;

export const auditLogKeys = defineQueryKeys('attendance-audit', (all) => ({
  /** 단일 근태 레코드의 감사 이력. */
  single: (attendanceId: string | undefined) => [...all, 'single', attendanceId] as const,

  /**
   * 전사 감사 로그.
   *
   * 페이지네이션·검색·필터가 **전부 키에 실린다**(9칸). `keepPreviousData` 로 페이지
   * 전환 깜빡임을 막으므로, 한 축이라도 키에서 빠지면 직전 결과가 새 조건의 답으로 보인다.
   */
  list: (
    limit: number,
    offset: number,
    search: string | undefined,
    action: string | undefined,
    filters: ViewFilters
  ) =>
    [
      ...all,
      'all',
      limit,
      offset,
      search,
      action,
      filters.userId,
      filters.startDate,
      filters.endDate,
    ] as const,
}));
